import feathers, { services } from '../../core/feathers'
import {
  clearNotifications,
  fetchNotifications,
  saveNotification
} from './actions'
import { NOTIFICATION_TYPE } from './constants'
import { cleanCurrentBidsForAuction } from '../bid'

export default function configure(dispatch, getState) {
  feathers.on('logout', () => {
    dispatch(clearNotifications())
  })
  feathers.on('login', userId => {
    dispatch(fetchNotifications())
  })
  services.notifications.on('created', notification => {
    if (
      notification.type === NOTIFICATION_TYPE.AUCTION_RESULT_LOST ||
      notification.type === NOTIFICATION_TYPE.AUCTION_RESULT_WON
    ) {
      if (notification.data) {
        // Auction result notifications contain nested JSON data
        notification.data = JSON.parse(notification.data)
      }
      dispatch(cleanCurrentBidsForAuction(notification.auctionId))
    }
    dispatch(saveNotification(notification))
  })
}



// WEBPACK FOOTER //
// ./src/services/notification/listeners.js